/* @flow */

import * as React from 'react';
import { compose, withProps } from 'recompose';
import moment from 'moment';
import 'moment-duration-format';

import Notification from 'app/components/notifications/Notification';
import withTimer from 'app/hoc/withTimer';
import t from 'app/utils/translate';

type Props = {
  subscribe: () => void,
  timeRemaining: number,
  unsubscribe: () => void
};

const TEN_MINUTES = 600000;

class ChallengeCountdownNotification extends React.Component<Props> {
  state = {
    hide: []
  };

  componentDidMount() {
    const { subscribe } = this.props;
    subscribe();
  }

  componentWillUnmount() {
    const { unsubscribe } = this.props;
    unsubscribe();
  }

  render() {
    const { timeRemaining } = this.props;
    const { hide } = this.state;

    if (timeRemaining > TEN_MINUTES) {
      return null;
    }

    if (timeRemaining <= 0) {
      return (
        !hide.includes('lockout') && (
          <Notification
            key="lockout"
            persist
            onClose={() => {
              this.setState({ hide: 'lockout' });
            }}
            type="danger"
          >
            <strong>Lockout!</strong> The {t('challenge')} will commence shortly
          </Notification>
        )
      );
    }

    const remainingStr = moment.duration(timeRemaining).format('mm:ss', { trim: false });
    return (
      !hide.includes('countdown') && (
        <Notification
          key="countdown"
          persist
          onClose={() => {
            this.setState({ hide: 'countdown' });
          }}
          type="warning"
        >
          <strong>HURRY!</strong> {remainingStr} until lockout
        </Notification>
      )
    );
  }
}

const enhance = compose(
  withTimer,
  withProps(props => ({
    timeRemaining: moment(props.startTime).diff(moment(props.timestamp))
  }))
);

export default enhance(ChallengeCountdownNotification);
